import trios from "../resources/scanner-logos/trios_logo.svg";
import dexis from"../resources/scanner-logos/dexis_logo.svg";
import itero from "../resources/scanner-logos/itero_logo.svg";
import dscore from "../resources/scanner-logos/dscore_logo.svg";
import dsconnect from "../resources/scanner-logos/dsconnect_logo.svg";
import medit from "../resources/scanner-logos/medit_logo.svg";
import carestream from "../resources/scanner-logos/carestream_logo.svg";
import panda from "../resources/scanner-logos/panda_logo.svg";
import straumann from "../resources/scanner-logos/straumann_logo.svg";
import shining3d from "../resources/scanner-logos/shining3d_logo.svg";
import aidite from "../resources/scanner-logos/aidite_logo_2.svg";
import runyes from "../resources/scanner-logos/runyes_logo.svg";
import alliedstar from "../resources/scanner-logos/alliedstar_logo.svg";
import neo_connect from "../resources/scanner-logos/neo-connect_logo.svg";
import eighteeth from "../resources/scanner-logos/eighteeth_logo.svg";
import three_disc from "../resources/scanner-logos/threedisc_logo.svg";

const portals = {
  1: {
    id: 1,
    databaseId: "",
    name: "3Shape Communicate Portal",
    display: "3Shape",
    logo: trios,
    status: "active",
    backgroundColor: "#C8143C",
    foregroundColor: "#FFFFFF",
    configuredId: null,
    StatusCode: "200",
    StatusMessage: "OK",
    Message: "",
    LastFetch: "2023-10-01T12:00:00Z",
    MinutesSinceLastFetch: 0, // Placeholder for minutes since last fetch
    organizationId: "",
    organizationName: "",
    WarnUser: false, // Placeholder for warning user
    WarnAdmin: false, // Placeholder for warning admin
  },
  2: {
    id:2,
    databaseId: "",
    name: "My Itero",
    display: "iTero",
    logo: itero,
    status: "active",
    backgroundColor: "#006AB0",
    foregroundColor: "#FFFFFF",
    configuredId: null,
    StatusCode: "200",
    StatusMessage: "OK",
    Message: "",
    LastFetch: "2023-10-01T12:00:00Z",
    MinutesSinceLastFetch: 0, // Placeholder for minutes since last fetch
    organizationId: "",
    organizationName: "",
    WarnUser: false, // Placeholder for warning user
    WarnAdmin: false, // Placeholder for warning admin

  },
  3: {
    id:3,
    databaseId: "",
    name: "DS Core",
    display: "DS Core",
    logo: dsconnect,
    status: "active",
    backgroundColor: "#D4F20A",  
    foregroundColor: "#3A3E3C",
    configuredId: null,
    StatusCode: "200",
    StatusMessage: "OK",
    Message: "",
    LastFetch: "2023-10-01T12:00:00Z",
    MinutesSinceLastFetch: 0, // Placeholder for minutes since last fetch
    organizationId: "",
    organizationName: "",
    WarnUser: false, // Placeholder for warning user
    WarnAdmin: false, // Placeholder for warning admin
  },
  4: {
    id:4,
    databaseId: "",
    name: "Medit Link",
    display: "Medit",
    logo: medit,
    status: "active",
    backgroundColor: "#004FEC",
    foregroundColor: "#FFFFFF",
    configuredId: null,
    StatusCode: "200",
    StatusMessage: "OK",
    Message: "",
    LastFetch: "2023-10-01T12:00:00Z",
    MinutesSinceLastFetch: 0, // Placeholder for minutes since last fetch
    organizationId: "",
    organizationName: "",
    WarnUser: false, // Placeholder for warning user
    WarnAdmin: false, // Placeholder for warning admin
  },
  // 5: {
  //   id:5,
  //   databaseId: "",
  //   name: "Sirona Connect Case Center",
  //   display: "Sirona",
  //   logo: dsconnect,
  //   status: "active",
  //   backgroundColor: "#575757",
  //   foregroundColor: "#FFFFFF",
  //   configuredId: null,
  //   StatusCode: "200",
  //   StatusMessage: "OK",
  //   Message: "",
  //   LastFetch: "2023-10-01T12:00:00Z",
  //   MinutesSinceLastFetch: 0, // Placeholder for minutes since last fetch
  //   organizationId: "",
  //   organizationName: "",
  //   WarnUser: false, // Placeholder for warning user
  //   WarnAdmin: false, // Placeholder for warning admin
  // },
  6: {
    id:6,
    databaseId: "",
    name: "Cs Connect",
    display: "Carestream",
    logo: carestream,
    status: "active",
    backgroundColor: "#FFB514",
    foregroundColor: "#FFFFFF",
    configuredId: null,
    StatusCode: "200",
    StatusMessage: "OK",
    Message: "",
    LastFetch: "2023-10-01T12:00:00Z",
    MinutesSinceLastFetch: 0, // Placeholder for minutes since last fetch
    organizationId: "",
    organizationName: "",
    WarnUser: false, // Placeholder for warning user
    WarnAdmin: false, // Placeholder for warning admin
  },
  7: {
    id:7,
    databaseId: "",
    name: "Dexis IS Connect",
    display: "Dexis",
    logo: dexis,
    status: "active",
    backgroundColor: "#EB6039",
    foregroundColor: "#FFFFFF",
    configuredId: null,
    StatusCode: "200",
    StatusMessage: "OK",
    Message: "",
    LastFetch: "2023-10-01T12:00:00Z",
    MinutesSinceLastFetch: 0, // Placeholder for minutes since last fetch
    organizationId: "",
    organizationName: "",
    WarnUser: false, // Placeholder for warning user
    WarnAdmin: false, // Placeholder for warning admin
  },
  8: {
    id:8,
    databaseId: "",
    name: "Shining 3D Dental Cloud",
    display: "Shining 3D",
    logo: shining3d,
    status: "active",
    backgroundColor: "#0073FE",
    foregroundColor: "#FFFFFF",
    configuredId: null,
    StatusCode: "200",
    StatusMessage: "OK",
    Message: "",
    LastFetch: "2023-10-01T12:00:00Z",
    MinutesSinceLastFetch: 0, // Placeholder for minutes since last fetch
    organizationId: "",
    organizationName: "",
    WarnUser: false, // Placeholder for warning user
    WarnAdmin: false, // Placeholder for warning admin
  },
  9: {
    id:9,
    databaseId: "",
    name: "Freqty Cloud",
    display: "Panda",
    logo: panda,
    status: "active",
    backgroundColor: "#063096",
    foregroundColor: "#FFFFFF",
    configuredId: null,
    StatusCode: "200",
    StatusMessage: "OK",
    Message: "",
    LastFetch: "2023-10-01T12:00:00Z",
    MinutesSinceLastFetch: 0, // Placeholder for minutes since last fetch
    organizationId: "",
    organizationName: "",
    WarnUser: false, // Placeholder for warning user
    WarnAdmin: false, // Placeholder for warning admin
  },
  10: {
    id:10,
    databaseId: "",
    name: "Straumann AXS",
    display: "Straumann",
    logo: straumann,
    status: "active",
    backgroundColor: "#3E6E39",
    foregroundColor: "#FFFFFF",
    configuredId: null,
    StatusCode: "200",
    StatusMessage: "OK",
    Message: "",
    LastFetch: "2023-10-01T12:00:00Z",
    MinutesSinceLastFetch: 0, // Placeholder for minutes since last fetch
    organizationId: "",
    organizationName: "",
    WarnUser: false, // Placeholder for warning user
    WarnAdmin: false, // Placeholder for warning admin
  },
  11: {
    id:11,
    databaseId: "",
    name: "Aidite Cloud",
    display: "Aidite",
    logo: aidite,
    status: "active",
    backgroundColor: "#0052a2",
    foregroundColor: "#FFFFFF",
    configuredId: null,
    StatusCode: "200",
    StatusMessage: "OK",
    Message: "",
    LastFetch: "2023-10-01T12:00:00Z",
    MinutesSinceLastFetch: 0, // Placeholder for minutes since last fetch
    organizationId: "",
    organizationName: "",
    WarnUser: false, // Placeholder for warning user
    WarnAdmin: false, // Placeholder for warning admin
  },
   12: {
    id:12,
    databaseId: "",
    name: "Runyes",
    display: "Runyes",
    logo: runyes,
    status: "active",
    backgroundColor: "#B41D48",
    foregroundColor: "#FFFFFF",
    configuredId: null,
    StatusCode: "200",
    StatusMessage: "OK",
    Message: "",
    LastFetch: "2023-10-01T12:00:00Z",
    MinutesSinceLastFetch: 0, // Placeholder for minutes since last fetch
    organizationId: "",
    organizationName: "",
    WarnUser: false, // Placeholder for warning user
    WarnAdmin: false, // Placeholder for warning admin
  },
  13: {
    id:13,
    databaseId: "",
    name: "Alliedstar",
    display: "Alliedstar",
    logo: alliedstar,
    status: "active",
    backgroundColor: "#0055d4",
    foregroundColor: "#FFFFFF",
    configuredId: null,
    StatusCode: "200",
    StatusMessage: "OK",
    Message: "",
    LastFetch: "2023-10-01T12:00:00Z",
    MinutesSinceLastFetch: 0, // Placeholder for minutes since last fetch
    organizationId: "",
    organizationName: "",
    WarnUser: false, // Placeholder for warning user
    WarnAdmin: false, // Placeholder for warning admin
  },
    14: {
    id:14,
    databaseId: "",
    name: "NeoConnect",
    display: "NeoConnect",
    logo: neo_connect,
    status: "active",
    backgroundColor: "#000000",
    foregroundColor: "#FFFFFF",
    configuredId: null,
    StatusCode: "200",
    StatusMessage: "OK",
    Message: "",
    LastFetch: "2023-10-01T12:00:00Z",
    MinutesSinceLastFetch: 0, // Placeholder for minutes since last fetch
    organizationId: "",
    organizationName: "",
    WarnUser: false, // Placeholder for warning user
    WarnAdmin: false, // Placeholder for warning admin
  },
  15: {
    id:15,
    databaseId: "",
    name: "Eighteeth",
    display: "Eighteeth",
    logo: eighteeth,
    status: "active",
    backgroundColor: "#1DAEE5",
    foregroundColor: "#FFFFFF",
    configuredId: null,
    StatusCode: "200",
    StatusMessage: "OK",
    Message: "",
    LastFetch: "2023-10-01T12:00:00Z",
    MinutesSinceLastFetch: 0, // Placeholder for minutes since last fetch
    organizationId: "",
    organizationName: "",
    WarnUser: false, // Placeholder for warning user
    WarnAdmin: false, // Placeholder for warning admin
  },
  16: {
    id:16,
    databaseId: "",
    name: "ThreeDisc",
    display: "3Disc",
    logo: three_disc,
    status: "active",
    backgroundColor: "#D74F1F",
    foregroundColor: "#FFFFFF",
    configuredId: null,
    StatusCode: "200",
    StatusMessage: "OK",
    Message: "",
    LastFetch: "2023-10-01T12:00:00Z",
    MinutesSinceLastFetch: 0, // Placeholder for minutes since last fetch
    organizationId: "",
    organizationName: "",
    WarnUser: false, // Placeholder for warning user
    WarnAdmin: false, // Placeholder for warning admin
  },
};

export default portals;
